const doc = [({"en":({"js":({"admin":({"highscore_generations":({"nav":({"overall_highscore":"Overall highscore", "participants":"Participants"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;